import { Locales } from "@simplyk/common";
import { useQuery } from "@tanstack/react-query";

import { useCurrentUserContext } from "@/common/contexts/CurrentUserContext";
import { useTranslate } from "@/common/hooks/useTranslate";
import { loadPreviewNamespaces } from "@/features/LiveFormEditor/LivePreview/contexts/PreviewLocaleProvider";

// Contacts read the default in the form's language, which the dashboard does not ship when it runs in another one.
export const useDefaultQuestionTitle = (formLocale: Locales, enabled: boolean): string | null => {
  const { t, i18n } = useTranslate();
  const { organization } = useCurrentUserContext();
  const language = formLocale.toLowerCase();
  const { isPending } = useQuery({
    queryKey: ["form-language-translations", language],
    queryFn: async () => {
      await loadPreviewNamespaces(i18n, [language], ["common"]);
      return true;
    },
    staleTime: Infinity,
    enabled,
  });

  return isPending
    ? null
    : t("common", "communicationPreferences.defaultQuestionTitle", {
        organizationName: organization?.name ?? "",
        lng: language,
      });
};
